import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-xl" }, "Order complete", -1)
const _hoisted_3 = { class: "govuk-panel govuk-panel--confirmation" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-panel__title" }, " Payment successful ", -1)
const _hoisted_5 = {
  key: 0,
  class: "govuk-panel__body"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Your order number is:")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, "Your order has been accepted and your documents are being processed.", -1)
const _hoisted_9 = { class: "govuk-body" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("View your orders")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" to download your documents. ")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-xl" }, "Sign in or create an account", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-inset-text" }, " You need an account to order and view your documents ", -1)
const _hoisted_15 = { class: "govuk-button-group" }
const _hoisted_16 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.paymentResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("strong", null, _toDisplayString(_ctx.paymentResult.orderNumber || _ctx.paymentResult.transactionReference), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: { name: 'Orders' },
            class: "govuk-link"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _hoisted_11
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: { name: 'Login', params: { redirect: 'PaySuccess' } },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                href: href,
                onClick: navigate,
                role: "button",
                draggable: "false",
                class: "govuk-button",
                "data-module": "govuk-button"
              }, " Sign in ", 8, _hoisted_16)
            ]),
            _: 1
          })
        ])
      ]))
}